'use strict';
// Display an address form, using the autocomplete feature
// of the Google Places API to help users fill in the information.
export default class PlaceAutocomplete {
    constructor() {
        try {
            var autocomplete;
            var $searchInput = $('#autocomplete');

            var componentForm = {
                street_number: 'short_name',
                route: 'long_name',
                locality: 'long_name',
                administrative_area_level_1: 'short_name',
                postal_code: 'short_name'
            };

            // Initialize library only if needed.
            if ($searchInput.length) {
                initAutocomplete();
            } else {
                return false;
            }

            $searchInput.on('focus', function () {
                geolocate();
            });

            function initAutocomplete() {
                // Create the autocomplete object, restricting the search to geographical location types.
                autocomplete = new google.maps.places.Autocomplete(
                    /** @type {!HTMLInputElement} */(document.getElementById('autocomplete')),
                    {
                        types: ['geocode'],
                        componentRestrictions: {country: "au"}
                    }
                );

                // When the user selects an address from the dropdown, populate the address
                // fields in the form.
                autocomplete.addListener('place_changed', fillInAddress);
            }

            function fillInAddress() {
                // Get the place details from the autocomplete object.
                var place = autocomplete.getPlace();

                var $input,
                    address = '';

                for (var component in componentForm) {
                    document.getElementById(component).value = '';
                }

                let locality, state, postcode;
                // Get each component of the address from the place details
                // and fill the corresponding field on the form.
                for (var i = 0; i < place.address_components.length; i++) {
                    var addressType = place.address_components[i].types[0];
                    var val = place.address_components[i][componentForm[addressType]];

                    if (componentForm[addressType]) {
                        //at times google returns St Mary's as Saint Marys, so we convert anything that says "Saint" to "St"
                        if(addressType == "locality" && val.indexOf("Saint Marys") > -1) {
                            val = val.replace("Saint Marys", "St Marys");
                        }

                        // DHL expects to get Street Number and Name in Address Line 1
                        // need to combine the two values
                        if (addressType === 'street_number') {
                            address += val + ' ';
                            $input = document.getElementById('route');
                        } else if (addressType === 'route') {
                            // Display address in Address Line 1, which was originally renamed 'street_number'.
                            $input = document.getElementById('street_number');
                            address += val;

                            // Get all the user entered values before a match with the first word from the Google result.
                            var regex = RegExp('^(.*?)' + val.split(' ', 1)[0]);
                            var result = regex.exec($searchInput.val());

                            // Add the street name to the user-entered unit & street number
                            if ( Array.isArray(result) ) {
                                address = result[1] + ' ' + val;
                            }

                            $input.value = address;
                        }
                        else {
                            $input = document.getElementById(addressType);
                            $input.value = val;
                            $($input).trigger("change");
                            if(addressType == "locality") {
                                locality = val;
                            }
                            if(addressType == "administrative_area_level_1") {
                                state = val;
                            }
                            if(addressType == "postal_code") {
                                postcode = val;
                            }
                        }

                        // Additional JS to trigger event on input in order to apply style
                        $input.focus();

                        // Make all the inputs readonly
                        // $input.readOnly = false;

                        // if ($input.tagName === 'SELECT') {
                        //     $input.disabled = false;
                        // }

                        // $input.parentElement.classList.add('readonly');
                    }
                }
                //set suburb state postcode
                let suburbStatePostcode = `${locality} ${state} ${postcode}`;
                // Create a DOM Option and pre-select by default
                var newOption = new Option(suburbStatePostcode,  Date.now().toString(), true, true);
                // Append it to the select
                $("#SuburbStatePostcode").append(newOption);
                $("#SuburbStatePostcode").data("api-value", suburbStatePostcode);
            }

            // Bias the autocomplete object to the user's geographical location,
            // as supplied by the browser's 'navigator.geolocation' object.
            function geolocate() {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (position) {
                        var geolocation = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        };
                        var circle = new google.maps.Circle({
                            center: geolocation,
                            radius: position.coords.accuracy
                        });
                        autocomplete.setBounds(circle.getBounds());
                    });
                }
            }
        } catch(ex){
            $(".place-autocomplete").hide();
            console.warn(ex);
        }
    }
}
